import { ThemeProvider as NextThemeProvider } from "next-themes";
import type { ReactNode } from "react";
import { useEmbeddedTheme } from "./embedded-appearance";

/**
 * 嵌入端主题边界（设计 §5.5.3）。
 *
 * 用 `forcedTheme` 接管 next-themes：主题完全由宿主 `appearance:update` 决定，
 * 既不读写 `tickbird.theme-mode`，也不跟随 iframe 自己的 `prefers-color-scheme`
 * ——那跟的是用户操作系统而不是宿主页面，跟随反而更容易与宿主撞色（AR-30）。
 *
 * `storageKey` 指向一个永远不会被写入的 key：嵌入端不调用 `setTheme`，
 * 这样即使同一浏览器里独立工作台留下过偏好，也不会漏进 iframe。
 */
const EMBEDDED_UNUSED_THEME_STORAGE_KEY = "tickbird.embedded.theme-mode.unused";

export function EmbeddedThemeProvider({ children }: { children: ReactNode }) {
  const { mode } = useEmbeddedTheme();

  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme={mode}
      disableTransitionOnChange
      enableSystem={false}
      forcedTheme={mode}
      storageKey={EMBEDDED_UNUSED_THEME_STORAGE_KEY}
    >
      {children}
    </NextThemeProvider>
  );
}
